import React, { Component } from "react";
import * as pr from "../../common/PrimeComponents";
import * as Log from "../../common/Feedback/Log";
import * as format from "../../common/FormatFunctions";
import { formatDate } from "fullcalendar";

export class BPMPickList extends Component {
  constructor(props) {
    super(props);
    console.log(props);
    this.state = {
      firstLoad: true
    };
  }

  componentDidMount = () => {
    // if (this.state.firstLoad) {
    //   if (format.isNotNull(this.props.targetList)) {
    //     console.log(this.props.sourceList);
    //     this.props.targetList.forEach(targetElem => {
    //       this.props.sourceList.filter(sourceElem => targetElem !== sourceElem);
    //     });
    //     console.log(this.props.sourceList);
    //     this.setState({ firstLoad: true });
    //   }
    //}
  };
  render() {
    return (
      <pr.PickList
        showSourceControls={false}
        showTargetControls={false}
        responsive={true}
        sourceHeader="Available"
        targetHeader="Selected"
        source={this.props.sourceList}
        target={this.props.targetList}
        onChange={e => {
          this.props.updateBean(this.props.targetField, e.target);
          this.props.updateState(this.props.sourceField, e.source);
        }}
        style={{ width: "100%" }}
      />
    );
  }
}
{
  /* <ListValueGenerator
type="DROPDOWN"
title="Attributes"
header="Select Attribute"
propertyPrefix="Value :"
listProperties={
  this.props.editedObject.attributeIdList
}
selectionOptions={this.props.attributeOptions}
listField="attributeIdList"
updateBean={this.props.updateValue}
updateSelection={this.props.updateState}
/> */
}



// WEBPACK FOOTER //
// ./src/components/Common/BPMPickList.js